module.exports = __webpack_public_path__ + "media/pdf/old-RESQ-banner-7a24ce4a.png";